import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { NgxSpinnerService } from "ngx-spinner";
import { publicEventApi } from "src/app/services/constants/api.constants";
import { environment } from "../../../environments/environment";
import { HttpBaseService } from "@evento-ng/libs";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
})
export class HomeComponent implements OnInit {
  cards: any[] = [];
  isMobile = false;
  previousCards: any[] = [];
  currentPage = 1;
  previousPage = 1;
  readonly take = 10;
  currentMeta: any;
  previousMeta: any;
  constructor(
    private dataService: HttpBaseService,
    private spinner: NgxSpinnerService,
    private translate: TranslateService
  ) {
    if (window.screen.width < 768) this.isMobile = true;
  }

  ngOnInit(): void {
    this.loadEvents();
    this.loadPreviousEvents();
  }

  loadEvents(): void {
    this.spinner.show();

    this.dataService
      .get(`${publicEventApi}?creatorId=${environment.CREATORID}`, {
        params: {
          page: this.currentPage,
          take: this.take,
        },
        headers: {
          "Accept-Language": this.translate.currentLang,
        },
      })
      .subscribe({
        next: (res) => {
          this.cards = res.data;
          this.currentMeta = res.meta;
          this.spinner.hide();
        },
        error: () => this.spinner.hide(),
      });
  }

  loadPreviousEvents(): void {
    this.spinner.show();

    this.dataService
      .get(`${publicEventApi}/previous/?creatorId=${environment.CREATORID}`, {
        params: {
          page: this.previousPage,
          take: this.take,
        },
        headers: {
          "Accept-Language": this.translate.currentLang,
        },
      })
      .subscribe({
        next: (res) => {
          this.previousCards = res.data;
          this.previousMeta = res.meta;
          this.spinner.hide();
        },
        error: () => this.spinner.hide(),
      });
  }

  goCurrentPage(page: number): void {
    this.currentPage = page;
    this.loadEvents();
  }

  nextCurrent(): void {
    this.currentPage++;
    this.loadEvents();
  }

  prevCurrent(): void {
    this.currentPage--;
    this.loadEvents();
  }

  goPreviousPage(page: number): void {
    this.previousPage = page;
    this.loadPreviousEvents();
  }

  nextPrevious(): void {
    this.previousPage++;
    this.loadPreviousEvents();
  }

  prevPrevious(): void {
    this.previousPage--;
    this.loadPreviousEvents();
  }
}
